export default class ServiceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/services/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/services', params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/services', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/services/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/services/' + id, params)
	}

	getEntitiesForSelectBox(operatorId, params) {
		return this.apiService.callGet(''+operatorId+'/services/simple', params)
	}

	// SEARCH
	searchServicesByNameOrId(params) {
		return this.apiService.callGet('me/services_search', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ServiceService.js